var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSertification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 83,
    viewBox: "0 0 78 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4248 57.1362V15.8466H66.3352V9.95703H60.4248H54.5352V63.0466H66.3352V57.1362H60.4248Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6875 9.95703V63.0466H36.5771V39.4466H42.4667V63.0466H48.3563V9.95703H30.6875ZM36.5771 33.557V15.8674H42.4667V33.557H36.5771Z",
    fill: "#43B02A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7766 15.8466V9.95703H12.9766V63.0466H24.7766V57.1362H18.887V39.4466H24.7766V33.557H18.887V15.8466H24.7766Z",
    fill: "#43B02A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSertification);
export default __webpack_public_path__ + "static/media/sertification.58166ea47b4f8bc6086b1a74001663a1.svg";
export { ForwardRef as ReactComponent };